import { ApiCreateExpenseCategory, ApiDeleteExpenseCategory, ApiGetExpenseCategoryList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function ExpenseCategoryService() {
    const { showFail } = useModal()

    const { fetch: apiGetExpenseCategoryList } = useFetch(ApiGetExpenseCategoryList)
    const { fetch: apiDeleteExpenseCategory } = useFetch(ApiDeleteExpenseCategory)
    const { fetch: apiCreateExpenseCategory } = useFetch(ApiCreateExpenseCategory)

    const fetchExpenseCategoryList = async(expenseCategoryName, status, pageSize, index) => {
        const res = await apiGetExpenseCategoryList({
            data: {
                expenseCategoryName,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteExpenseCategory = async(expenseCategoryId, status) => {
        const res = await apiDeleteExpenseCategory({
            data: {
                expenseCategoryId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateExpenseCategory = async(expenseCategoryName, description) => {
        const res = await apiCreateExpenseCategory({
            data: {
                expenseCategoryName,
                description
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchExpenseCategoryList,
        fetchDeleteExpenseCategory,
        fetchCreateExpenseCategory
    }
}